﻿// site.js

; (() => {
    const root = document.documentElement;
    const nav = document.getElementById('main-nav');
    const contact = document.getElementById('contact-bar');
    const btn = document.getElementById('menuToggle');
    const menu = document.getElementById('mobile-menu');

    if (!nav) return;

    const TRIGGER = 12;
    const HYST = 6;
    let expandedH = 64,
        compactH = 56,
        contactH = 0,
        state = 'top',
        ticking = false;

    function setPx(name, val) {
        root.style.setProperty(name, val + 'px');
    }

    function measureHeights() {
        const isDesktop = window.matchMedia('(min-width: 992px)').matches;
        contactH = (isDesktop && contact) ? contact.offsetHeight : 0;

        nav.classList.remove('scrolled');
        const navExpanded = nav.offsetHeight;
        nav.classList.add('scrolled');
        const navCompact = nav.offsetHeight;
        nav.classList.remove('scrolled');

        expandedH = navExpanded + contactH;
        compactH = navCompact + contactH;

        setPx('--header-expanded-height', expandedH);
        setPx('--header-compact-height', compactH);
        setPx('--header-layout-height', expandedH);
        setPx('--nav-height', navExpanded);
    }

    function applyState(next) {
        if (state === next) return;
        state = next;

        if (state === 'top') {
            nav.classList.add('snap');
            nav.classList.remove('scrolled');

            setPx('--nav-height', expandedH - contactH);
            setPx('--header-layout-height', expandedH);

            void nav.offsetHeight;
            requestAnimationFrame(() => nav.classList.remove('snap'));
        } else {
            nav.classList.add('scrolled');
            setPx('--nav-height', compactH - contactH);
        }
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            const y = window.scrollY || document.documentElement.scrollTop;
            if (state === 'top' && y > TRIGGER + HYST) applyState('scrolled');
            else if (state === 'scrolled' && y < TRIGGER - HYST) applyState('top');
            ticking = false;
        });
    }

    function onResize() {
        const prev = state;
        measureHeights();
        applyState(prev);
    }

    function openMenu() {
        if (!menu || !btn) return;
        menu.classList.add('open');
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        document.body.classList.add('menu-open');
    }

    function closeMenu() {
        if (!menu || !btn) return;
        menu.classList.remove('open');
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('menu-open');
    }

    function toggleMenu() {
        if (!menu) return;
        if (menu.classList.contains('open')) closeMenu();
        else openMenu();
    }

    document.addEventListener('DOMContentLoaded', () => {
        measureHeights();
        applyState('top');

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', onResize);
        window.addEventListener('load', onResize);

        const logo = document.querySelector('.brand-logo');
        if (logo && !logo.complete) {
            logo.addEventListener('load', onResize, { once: true });
        }

        document.addEventListener('shown.bs.collapse', onResize);
        document.addEventListener('hidden.bs.collapse', onResize);

        if (btn) {
            btn.addEventListener('click', toggleMenu);
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') closeMenu();
            });
        }

        if (menu) {
            menu.addEventListener('click', (e) => {
                const a = e.target.closest('a');
                if (a) closeMenu();
            });
        }
    });
})();

; document.addEventListener('DOMContentLoaded', () => {
    const animated = document.querySelectorAll('[data-animate]');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.15 });

    animated.forEach((el) => observer.observe(el));
});